import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setEntryPoint, clearEntryPoint } from './modules/Session/actions';

function MainApp({ children }) {
  const dispatch = useDispatch();
  // const currentLocation = useSelector((state) => state.location.currentLocation);

  useEffect(() => {
    // On initial mount we want to store the entry point of the app
    // in the redux store so that we can use it later
    // to determine if we should show the login screen or not
    dispatch(setEntryPoint());

    return () => {
      dispatch(clearEntryPoint());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {children}
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(
  MainApp,
);